import { EmbedTypes } from '../enums';
import { getElementAttribute } from './domElementsUtil';

function filterAttnArticles(articleUrl) {
    const regexFilter = /((https?:\/\/)?.+\/\w+\/\d+)\//;
    const match = regexFilter.exec(articleUrl);

    if (match && match.length > 0) {
        const filterdUrl = match[1];

        return articleUrl.indexOf(filterdUrl) !== -1 ? filterdUrl : articleUrl;
    }

    return articleUrl;
}

function filterRefinery29Articles(articleUrl) {
    if (articleUrl.indexOf('/amp/') > 0) {
        return articleUrl.replace('amp/', '');
    }

    return articleUrl;
}

function filterRefinery29AmpProjectArticles(articleUrl) {
    const refineryCdnFlag = '/v/s/';
    if (articleUrl.indexOf(refineryCdnFlag) > 0) {
        const filteredUrl = articleUrl.substring(
            articleUrl.indexOf(refineryCdnFlag) + refineryCdnFlag.length
        );

        // eslint-disable-next-line no-use-before-define
        return filterUrlArticleByPublisherDomain(filteredUrl);
    }

    return articleUrl;
}

function filterGoogleAmpArticles(articleUrl) {
    const ampStartFlag = '/amp/s/';
    if (articleUrl.indexOf(ampStartFlag) > 0) {
        const filteredUrl = articleUrl.substring(
            articleUrl.indexOf(ampStartFlag) + ampStartFlag.length
        );

        // eslint-disable-next-line no-use-before-define
        return filterUrlArticleByPublisherDomain(filteredUrl);
    }

    return articleUrl;
}

const urlFilters = [
    {
        domainPattern: /^google\..*/,
        filter: filterGoogleAmpArticles
    },
    {
        domain: 'attn.com', // ATTN
        filter: filterAttnArticles
    },
    {
        domain: 'refinery29.com', // Refinery 29
        filter: filterRefinery29Articles
    },
    {
        domain: 'www-refinery29-com.cdn.ampproject.org',
        filter: filterRefinery29AmpProjectArticles // Refinery 29 AMP CDN
    }
];

export function getCurrentArticle(container, embedType) {
    let url = null;

    if (
        embedType === EmbedTypes.NormalWidgetId ||
        embedType === EmbedTypes.IframeWidgetId ||
        embedType === EmbedTypes.IFramely ||
        embedType === EmbedTypes.IframeOnly
    ) {
        // for widgetId embed

        const articleUrlAttribute = getElementAttribute(
            container,
            'action-button-article-url',
            'actionButtonArticleUrl'
        );

        if (articleUrlAttribute != null && articleUrlAttribute.length > 0) {
            url = articleUrlAttribute;
            return url;
        }
    }

    const canonical = document.querySelector("link[rel='canonical']");
    const fbUrl = document.querySelector("meta[property='og:url']");

    let usedLocationHref = false;

    if (canonical) {
        url = decodeURIComponent(canonical.getAttribute('href'));
    } else if (fbUrl) {
        url = fbUrl.content;
    } else if (
        typeof window !== 'undefined' &&
        window.location.href.indexOf('?') !== -1
    ) {
        url = window.location.href.split('?')[0];
        usedLocationHref = true;
    } else {
        url = window.location.href;
        usedLocationHref = true;
    }

    /* eslint-disable no-restricted-globals */
    const isInIframe = parent !== window;
    if (usedLocationHref && isInIframe && (document.referrer || document.baseURI)) {
        url = document.referrer || document.baseURI;

        if (url.indexOf('?') !== -1) {
            url = url.split('?')[0];
        }
    }

    return url;
}

export function filterUrlArticleByPublisherDomain(container, embedType) {
    const articleUrl = getCurrentArticle(container, embedType);

    /* eslint-disable no-useless-escape */
    const domainRegex = /^(?:https?:\/\/)?(?:[^@\/\n]+@)?(?:www\.)?([^:\/\n]+)/;
    const match = domainRegex.exec(articleUrl);
    if (match == null || match.length < 2) return articleUrl;

    const domain = match[1]; // first capturing group is the domain
    const publisherUrlFilters = urlFilters.filter(
        urlFilter =>
            (urlFilter.domain && urlFilter.domain === domain) ||
            (urlFilter.domainPattern && domain.match(urlFilter.domainPattern))
    );

    if (!publisherUrlFilters || !publisherUrlFilters.length) return articleUrl;

    let filterdArticleUrl = articleUrl;

    publisherUrlFilters.forEach(urlFilter => {
        filterdArticleUrl = urlFilter.filter(filterdArticleUrl);
    });

    return filterdArticleUrl;
}



// WEBPACK FOOTER //
// ./src/utils/pageData/articleUrlProcessor.js